import MDB from '../marketingdb';

/**
 * Create a new color generator
 * @return {function(seed: string): string}
 */
const createColorGenerator = () => MDB.Charts.createColorGenerator();

/**
 * Hex color generator
 */
class ColorGenerator {
    get _internalGenerator(){
        if(this._cachedInternalGenerator){
            return this._cachedInternalGenerator;
        }

        this._cachedInternalGenerator = createColorGenerator();
        return this._cachedInternalGenerator;
    }
    
    constructor() {
        this._cachedInternalGenerator = null;
    }

    /**
     * Generate a color based on the given seed
     * @param seed
     */
    generateSeededColor(seed){
        return this._internalGenerator(seed);
    }
}

export {
    ColorGenerator
}